import store from "../../new_player/player-store"
import { isEmbed } from "../../new_player/presentation-types"
import {
  getSlideAdOverlayByIndex,
  interstitialAdOverlays,
  interstitialDismissButtons,
  nextSlideNavigation,
  player,
  previousSlideNavigation,
  progressBar,
  slideContainer,
} from "../../new_player/selectors"
import { getFlagValue } from "../../utils/ab_tests"

const INTERSTITIAL_EVERY_X_SLIDES = 4

export const prepareInterstitialAd = (slideIndex) => {
  const adOverlay = getSlideAdOverlayByIndex(slideIndex)
  const skipButton = adOverlay.find(".skip-ad-button")

  store.isShowingAd = true
  player.addClass("showing-ad")
  adOverlay.fadeIn()
  skipButton.addClass("waiting-to-skip")
  skipButton.prop("disabled", true)
}

export const shouldShowInterstitialAd = async (navigationCount) => {
  if (isEmbed()) {
    return false
  }

  const isFeatureFlagActive = await getFlagValue("interstitial_ads_flag")
  if (!isFeatureFlagActive) {
    return false
  }
  return navigationCount && navigationCount % INTERSTITIAL_EVERY_X_SLIDES === 0
}

const unfreezeNavigation = () => {
  nextSlideNavigation.prop("disabled", false)
  previousSlideNavigation.prop("disabled", false)
  progressBar.removeClass("disabled")
  store.isNavigationLocked = false
}

export const freezeSwiping = () => {
  slideContainer.addClass("swipe-disabled")
}

const unfreezeSwiping = () => {
  slideContainer.removeClass("swipe-disabled")
}

export const skipAd = () => {
  unfreezeSwiping()
  interstitialAdOverlays.fadeOut()
  player.removeClass("showing-ad")
  store.isShowingAd = false
}

const iterateAdCountdown = (secondsRemaining, index) => {
  const countdown = getSlideAdOverlayByIndex(index).find(".ad-countdown")
  const skipButton = getSlideAdOverlayByIndex(index).find(".skip-ad-button")

  if (secondsRemaining > 0) {
    countdown.text(secondsRemaining)

    setTimeout(() => {
      iterateAdCountdown(secondsRemaining - 1, index)
    }, 1000)
  } else {
    countdown.text("")
    skipButton.prop("disabled", false)
    skipButton.removeClass("waiting-to-skip")
    unfreezeNavigation()
  }
}

export const initializeInterstitialAds = () => {
  interstitialDismissButtons.on("click", (e) => {
    e.stopPropagation()
    skipAd()
  })
}

export const freezeNavigation = (index) => {
  nextSlideNavigation.prop("disabled", true)
  previousSlideNavigation.prop("disabled", true)
  progressBar.addClass("disabled")
  store.isNavigationLocked = true

  iterateAdCountdown(3, index)
}
